import React from "react"
import { Flex, Text, Box, Heading, Link } from "@chakra-ui/react"
import { css } from "@emotion/react"
import { LinkedinIcon } from "react-share"
import { colors } from "../colors/colors"
import { CloseButton } from "../button/CloseButton"
import { Image } from "../image/Image"

function DescriptionSection({ item, ...rest }) {
  return (
    <Box alignSelf="flex-end" flex="1 0 0px" {...rest}>
      <Heading
        as="h3"
        fontSize={20}
        lineHeight="29px"
        m={`0`}
        textTransform="uppercase"
        textAlign="left"
        fontWeight={600}
        color="black"
      >
        {item?.title}
      </Heading>
      <Heading
        as="p"
        color={colors.blue}
        fontSize={16}
        textTransform="uppercase"
        m={0}
        lineHeight="20px"
        fontWeight={600}
      >
        {item?.teamFields?.role}
      </Heading>

      {item?.teamFields?.linkedin && (
        <Box width="24px" height="24px" mt="7px">
          <Link href={item?.teamFields?.linkedin} target="_blank">
            <LinkedinIcon
              bgStyle={{ fill: colors.blue }}
              style={{ width: 24, height: 24 }}
            />
          </Link>
        </Box>
      )}
    </Box>
  )
}

function ContentSection({ item, mt, ...rest }) {
  return (
    <Box flexBasis={{ base: `100%`, lg: "67%" }} {...rest}>
      <Text
        mt={mt}
        maxHeight="250px"
        overflow="hidden"
        color="black"
        fontSize="14px"
        lineHeight="22px"
        dangerouslySetInnerHTML={{ __html: item?.content }}
      />
    </Box>
  )
}

export function TileExpanded({
  showExpandedInline,
  display,
  onReset,
  onClick,
  item,
}) {
  const image =
    item?.teamFields?.youthPhoto?.localFile ||
    item?.featuredImage?.node?.localFile
  return (
    <Box
      key={item?.id}
      bg={colors.bggray}
      display={display}
      gridColumn={{
        base: `span 6`,
        sm: `span 4`,
        md: `span 8`,
        lg: `span 6`,
      }}
    >
      <Box
        onClick={onClick}
        p={{ lg: `22px 11px 22px 22px`, base: "22px" }}
        position="relative"
      >
        <Flex flexWrap={{ base: `wrap`, md: `nowrap` }} zIndex={6}>
          <Box
            flexBasis={{ sm: `33%` }}
            p={0}
            textAlign="left"
            bg={`transparent`}
          >
            <Box
              maxWidth={{
                sm: "180px",
                md: `250px`,
                lg: `180px`,
              }}
              m={{ base: `0 auto`, md: `0` }}
            >
              {image && (
                <Image className={css({ width: `100%` })} image={image} />
              )}
            </Box>

            <DescriptionSection
              item={item}
              display={{
                base: `initial`,
                sm: `none`,
                md: `initial`,
                lg: `none`,
              }}
            />
          </Box>

          <DescriptionSection
            item={item}
            ml="20px"
            display={{ lg: `initial`, md: `none`, sm: `initial`, base: `none` }}
          />

          <ContentSection
            display={{ lg: "none", md: `initial`, sm: `none`, base: `initial` }}
            ml={{ sm: `15px` }}
            item={item}
          />

          <Box textAlign="right">
            <CloseButton
              height="20px"
              color={colors.gray}
              hoverColor={colors.purple}
              onClick={onReset}
            />
          </Box>
        </Flex>

        <ContentSection
          display={{ lg: "initial", md: `none`, sm: `initial`, base: `none` }}
          mt="15px"
          item={item}
        />
      </Box>
    </Box>
  )
}
